export default function DownloadIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3V11H16L12 15L8 11H11V3H13ZM3 19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V14H19V19H5V14H3V19Z"
        fill="currentColor"
      />
    </svg>
  );
}
